import React from 'react'
import _ from 'lodash'
import SkyLight from 'react-skylight'
import ViewStatics from '../ViewStatics/ViewStatics'
import ViewStaticsDouble from '../ViewStatics/ViewStaticsDouble'
import warningData from '../../img/icons/general-icons/icon_warning.png'
// import Charline from './Charline'

export default class DashboardMedicalData extends React.Component {

  constructor(props) {
      super(props);
      console.log('====================', props.lastEstadoSalud.balanceNeuroMuscularT )
  }

  render () {

    var settings = {
        backgroundColor: '#1A3B4E',
        color: '#ffffff',
        width: '50%',
        height: 'auto',
        border: '1px solid #FFFFFF',
        fontSize: '14px',
        display: 'flex !important',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }

    return (

      <div className='patient-medical-information'>
        <div className='global-medical-container'>
          <div className='medical-name'>P.A Parado</div>
          <div className='medical-data'>{this.props.lastEstadoSalud.sistoleParado + ' / ' + this.props.lastEstadoSalud.diastoleParado}</div>
          <div className='medical-icon'>{(this.props.lastEstadoSalud.sistoleParado > 220 || this.props.lastEstadoSalud.sistoleParado < 90 || this.props.lastEstadoSalud.diastoleParado > 120 || this.props.lastEstadoSalud.diastoleParado < 60) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>

          <span onClick={() => this.refs.papDialog.show()}>
            <ViewStaticsDouble {...{data:this.props.estadoSaludData, index:'sistoleParado', index2:'diastoleParado', media: 120, media2: 80, domain: [0,250]}}/>
          </span>

          <SkyLight dialogStyles={settings} ref='papDialog' hideOnOverlayClicked title='Presión arterial parado'>
            <div className="chart-modal-container">
              <ViewStaticsDouble {...{data:this.props.estadoSaludData, index:'sistoleParado', index2:'diastoleParado', media: 120, media2: 80, domain: [0,250]}}/>
            </div>
          </SkyLight>

          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>P.A. Sentado</div>
          <div className='medical-data'>{this.props.lastEstadoSalud.sistoleSentado + ' / ' + this.props.lastEstadoSalud.diastoleSentado}</div>
          <div className='medical-icon'>{(this.props.lastEstadoSalud.sistoleSentado > 220 || this.props.lastEstadoSalud.sistoleSentado < 90 || this.props.lastEstadoSalud.diastoleSentado > 120 || this.props.lastEstadoSalud.diastoleSentado < 60) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.pasDialog.show()}>
            <ViewStaticsDouble {...{data:this.props.estadoSaludData, index:'sistoleSentado', index2:'diastoleSentado', media: 120, media2: 80, domain: [0,250]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='pasDialog' hideOnOverlayClicked title='Presión arterial sentado'>
            <div className="chart-modal-container">
              <ViewStaticsDouble {...{data:this.props.estadoSaludData, index:'sistoleSentado', index2:'diastoleSentado', media: 120, media2: 80, domain: [0,250]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>F.C</div>
          <div className='medical-data'>{this.props.lastEstadoSalud.frecuencia}</div>
          <div className='medical-icon'>{(this.props.lastEstadoSalud.frecuencia < 50 || this.props.lastEstadoSalud.frecuencia > 90) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.fcDialog.show()}>
            <ViewStatics {...{data:this.props.estadoSaludData, index:'frecuencia', media: 70, domain: [0,100]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='fcDialog' hideOnOverlayClicked title='Frecuencia cardiaca'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.estadoSaludData, index:'frecuencia', media: 70, domain: [0,100]}}/>
            </div>
          </SkyLight>
          </div>
        </div>

        { this.props.lastEstadoSalud.balanceNeuroMuscularT > 0  &&
        
          <div className='global-medical-container'>
            <div className='medical-name'>Balance</div>
            <div className='medical-data'>{this.props.lastEstadoSalud.balanceNeuroMuscularT}</div>
            <div className='medical-icon'>{(this.props.lastEstadoSalud.balanceNeuroMuscularT < 10 || this.props.lastEstadoSalud.balanceNeuroMuscularT > 45) ? <img src={warningData}/> : null}</div>
            <div className='medical-graph'>
            <span onClick={() => this.refs.bnDialog.show()}>
              <ViewStatics {...{data:this.props.estadoSaludData, index:'balanceNeuroMuscularT', media: 20, domain: [0,50]}}/>
            </span>
            <SkyLight dialogStyles={settings} ref='bnDialog' hideOnOverlayClicked title='Balance'>
              <div className="chart-modal-container">
                <ViewStatics {...{data:this.props.estadoSaludData, index:'balanceNeuroMuscularT', media: 20, domain: [0,50]}}/>
              </div>
            </SkyLight>
            </div>
          </div>
        
        }

        { this.props.lastEstadoSalud.gripT > 0 &&
        <div className='global-medical-container'>
          <div className='medical-name'>Grip</div>
          <div className='medical-data'>{this.props.lastEstadoSalud.gripT}</div>
          <div className='medical-icon'>{(this.props.lastEstadoSalud.gripT < 10 || this.props.lastEstadoSalud.balanceNeuroMuscularT > 42) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.bnDialog.show()}>
            <ViewStatics {...{data:this.props.estadoSaludData, index:'gripT', media: 20, domain: [0,50]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='bnDialog' hideOnOverlayClicked title='Grip'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.estadoSaludData, index:'gripT', media: 20, domain: [0,50]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        }

        <div className='global-medical-container'>
          <div className='medical-name'>IMC</div>
          <div className='medical-data'>{this.props.lastEstadoSalud.imc}</div>
          <div className='medical-icon'>{/*(this.props.lastEstadoSalud.peso < 50 || this.props.lastEstadoSalud.peso > 110) ? <img src={warningData}/> : null*/}</div>
          <div className='medical-graph'>
            <span onClick={() => this.refs.pesoDialog.show()}>
              <ViewStatics {...{data:this.props.estadoSaludData, index:'imc', media: 70, domain: [0,140]}}/>
            </span>
            <SkyLight dialogStyles={settings} ref='pesoDialog' hideOnOverlayClicked title='Imc'>
              <div className="chart-modal-container">
                <ViewStatics {...{data:this.props.estadoSaludData, index:'imc', media: 70, domain: [0,140]}}/>
              </div>
            </SkyLight>
          </div>
        </div>


      </div>
    )
  }
}

/* Validate Props */
DashboardMedicalData.propTypes = {
  estadoSaludData: React.PropTypes.arrayOf(React.PropTypes.object),
  lastEstadoSalud: React.PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/EstaDoSaludDashboard/DashboardMedicalData.js